export default [
  "$scope",
  "$timeout",
  "Events",
  "UserService",
  "$analytics",
  "$window",
  "_",
  "RequestService",
  "LocaleService",
  "ConfigService",
  "FeatureService",
  "matchmedia",
  "$state",
  "$rootScope",
  "$cookies",
  "$http",
  "MenuService",
  "AuthenticationService",
  "SessionExpirationService",
  "MaintenanceService",
  "TreeFilterService",
  function AppController(
    $scope,
    $timeout,
    Events,
    UserService,
    $analytics,
    $window,
    _,
    RequestService,
    LocaleService,
    ConfigService,
    FeatureService,
    matchmedia,
    $state,
    $rootScope,
    $cookies,
    $http,
    MenuService,
    AuthenticationService,
    SessionExpirationService,
    MaintenanceService,
    TreeFilterService
  ) {
    var scope = this;

    scope.currentBackgroundImage = null;

    function getDefaultStyles() {
      return { display: "block" };
    }

    scope.globalErrorStyles = { display: "none" };
    scope.styles = getDefaultStyles();
    scope.backgroundImageIndex = 0;

    MaintenanceService.init();
    scope.maintenance = MaintenanceService.getIsMaintenance();
    scope.showGlobalError = MaintenanceService.getShowGlobalError();
    scope.showRequestError = MaintenanceService.getShowRequestError();
    scope.currentContext = ConfigService.getContext();

    function getShowMainContent() {
      return !scope.maintenance && !scope.showRequestError;
    }

    scope.showMainContent = getShowMainContent();

    scope.filterChanged = () => {
      $rootScope.$emit(Events.CONTRACT_FILTER_CHANGED, {});
    };

    $rootScope.$on(Events.SHOW_GLOBAL_ERROR, () => {
      $timeout(() => {
        scope.showGlobalError = MaintenanceService.getShowGlobalError();
        scope.showMainContent = getShowMainContent();

        if (scope.showGlobalError) {
          scope.globalErrorStyles = { display: "block" };
        } else {
          scope.globalErrorStyles = { display: "none" };
        }


      }, 200);
    });

    $rootScope.$on(Events.SHOW_REQUEST_ERROR, () => {
      $timeout(() => {
        scope.showRequestError = MaintenanceService.getShowRequestError();
        scope.showMainContent = getShowMainContent();

      }, 200);
    });

    scope.shortcut = (value) => {
      if (ConfigService.get("enableBackgroundShortcuts", true, false)) {
        //console.log("keypress: ", value, scope.backgroundImageIndex);
        if (value.keyCode === 37) {
          //console.log("previous");
          scope.styles = getBackgroundStyles(scope.backgroundImageIndex - 1);
        }

        if (value.keyCode === 39) {
          //console.log("next");
          scope.styles = getBackgroundStyles(scope.backgroundImageIndex + 1);
        }
      }
    };

    $rootScope.$on("storeTree", function (event, data) {
      // console.log("store Tree Data:", data);
      $rootScope.treeData = _.cloneDeep(data.items);
      $rootScope.selectedTreeItems = data.selectedItems;
    });

    $rootScope.$on("clearTree", function (event, data) {
      TreeFilterService.treeData = undefined;
      TreeFilterService.openItems = undefined;
      TreeFilterService.closedItems = undefined;
      TreeFilterService.selectedItems = undefined;
    });

    $rootScope.$watch("treeData", function (n, o) {
      // console.log("tree data changed: ", n,o);
    });

    /*var onToggleSidebar = $rootScope.$on(Events.NAV_TOGGLE_SIDEBAR, function (e, data) {
          //console.log("Toggle Sidebar");
          if (scope.showLoginClass) {   
             
            if(data){
                scope.styles["background-position-x"] = "150px";
            }else{
                scope.styles["background-position-x"] = "0px";
            }
          }
    });*/

    function getScreenSize() {
      var width = window.innerWidth;
      if (width >= 1280) {
        return "Large";
      } else if (width >= 640) {
        return "Medium";
      } else {
        return "Small";
      }
    }

    function getBackgroundStyles(index) {
      var styles = getDefaultStyles();
      var screenSize = getScreenSize();
      var backgroundImageUrl = ConfigService.get("backgroundImageUrl", true);
      var screenBackgroundImageUrl = ConfigService.get(
        "backgroundImageUrl" + screenSize,
        true
      );

      if (screenBackgroundImageUrl !== undefined) {
        backgroundImageUrl = screenBackgroundImageUrl;
      }

      if (backgroundImageUrl) {
        if (_.isArray(backgroundImageUrl)) {
          var randomImage = _.sample(backgroundImageUrl);
          if (index !== undefined) {
            index = index >= backgroundImageUrl.length ? 0 : index;
            index = index < 0 ? backgroundImageUrl.length - 1 : index;
            randomImage = backgroundImageUrl[index];
            scope.backgroundImageIndex = index;
          }
          if (scope.currentBackgroundImage === null || index !== undefined) {
            scope.currentBackgroundImage = randomImage;
          }
        } else {
          if (scope.currentBackgroundImage === null) {
            scope.currentBackgroundImage = backgroundImageUrl;
          }
        }

        styles["background-image"] =
          'url("' + scope.currentBackgroundImage + '")';
      }
      return styles;
    }

    $rootScope.isPhone = matchmedia.isPhone();
    $rootScope.isTablet = matchmedia.isTablet();
    //(ga) $http.defaults.headers.common['X-XSRF-TOKEN'] = $cookies.get("XSRF-TOKEN");

    scope.showLoginClass =
      $state.is("login") ||
      $state.is("forgotPassword") ||
      $state.is("resetPassword");

    if (scope.showLoginClass) {
      scope.styles = getBackgroundStyles();
    } else {
      scope.styles = getDefaultStyles();
    }

    SessionExpirationService.init();
    //MaintenanceService.init();

    var bypass;
    var assignBypassFromQueryParam = false;

    var stateChangeStartCanceler = $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams) {
        if (toParams.bypass !== undefined && !assignBypassFromQueryParam) {
          bypass = toParams.bypass;
          assignBypassFromQueryParam = true;
        }

        //console.log("STATE CHANGE : ", fromState,fromParams, toState,toParams,bypass);

        //$rootScope.$emit("login:changeVisibility", false);

        var browserLanguage =
          $window.navigator.language || $window.navigator.userLanguage;

        //console.log("FROM PARAMS: ", fromParams);

        function replaceNotWanted(href) {
          if (href) {
            return href.replace("#", "").replace("//", "");
          } else {
            return href;
          }
        }

        function transitionTo(
          toState,
          toParams,
          fromState,
          fromParams,
          reload
        ) {
          bypass = true;
          assignBypassFromQueryParam = false;
          //scope.showLoginClass = false;
          let locale = fromParams.locale || browserLanguage;
          let href = $state.href(
            toState,
            { locale: locale },
            { absolute: false }
          );
          let hrefWithoutLocale2 = $state.href(
            toState,
            {},
            { absolute: false }
          );
          let hrefWithoutLocale = hrefWithoutLocale2.replace(locale, "");

          hrefWithoutLocale = replaceNotWanted(hrefWithoutLocale);
          hrefWithoutLocale2 = replaceNotWanted(hrefWithoutLocale2);

          if (href && href.length > 2) {
            href = href.substring(2);
          }

          //console.log("pageTrack: ", hrefWithoutLocale, hrefWithoutLocale2);
          $analytics.pageTrack(hrefWithoutLocale);

          if (AuthenticationService.isAuthenticated()) {
            let menu = MenuService.findMenuByState(toState.name);
            let description;

            if (menu) {
              description = LocaleService.get(menu.description);
            }

            UserService.trackActivity("view." + toState.name, {
              url: hrefWithoutLocale,
              params: toParams,
              text: description,
            });
          }
          $state.go(toState, toParams, {
            reload: reload,
          });
        }

        function transitionToLogin(fromState, fromParams, toState, toParams) {
          if (ConfigService.isSessionStorageAvailable()) {
            if (!sessionStorage.getItem("afterLoginPath")) {
              sessionStorage.setItem("afterLoginPath", toState.name);
              sessionStorage.setItem(
                "afterLoginParams",
                JSON.stringify(toParams)
              );
            }
          }

          transitionTo(
            "login",
            { locale: locale },
            fromState,
            fromParams,
            true
          );
        }

        function transitionToState(fromState, fromParams, toState, toParams) {
          /*if (ConfigService.isLocalStorageAvailable()) {
                    localStorage.removeItem("afterLoginPath");
                    localStorage.removeItem("afterLoginParams");
                }*/
          transitionTo(toState, toParams, fromState, fromParams, false);
        }

        // console.log("NAVIGATE state: ", toState, bypass, toState.data,toState.data.showLoginClass);

        if (toState.data && toState.data.showLoginClass) {
          SessionExpirationService.disable();
          //MenuService.menus = MenuService.setMenus(MenuService.loginMenus);
          scope.showLoginClass = true;
          scope.styles = getBackgroundStyles();
        } else {
          SessionExpirationService.init();
          //MenuService.menus = MenuService.setMenus(MenuService.normalMenus);
          scope.showLoginClass = false;
          scope.styles = getDefaultStyles();
        }

        if (bypass) {
          $rootScope.$emit("login:changeVisibility", true);
          bypass = false;
          return;
        }
        event.preventDefault();
        //LocaleService.loadStrings("de-AT").then((locale)=>{

        if (
          (toState.data &&
            toState.data.anonymousAccess !== true &&
            !toState.data.isRoot) ||
          !toState.data
        ) {
          //restricted access
          //event.preventDefault();
          //var menu = MenuService.findMenuByState(toState.name);
          //console.log("found menu: ", menu);

          AuthenticationService.reloadUser().then(
            function (user) {
              if (AuthenticationService.isAuthenticated()) {
                //console.log("userCheck: ", menu, menu.state, menu.executeUserCheck);
                if (toState.executeUserCheck) {
                  if (!toState.executeUserCheck(user)) {
                    transitionToLogin(fromState, fromParams, toState, toParams);
                  }
                }

                //console.log("check for feature: ", menu, menu.feature);
                if (toState && toState.feature) {
                  FeatureService.hasFeature(toState.feature).then(function (
                    hasFeature
                  ) {
                    if (hasFeature) {
                      transitionToState(
                        fromState,
                        fromParams,
                        toState,
                        toParams
                      );
                      // Continue with the initial state change
                    } else {
                      transitionToLogin(
                        fromState,
                        fromParams,
                        toState,
                        toParams
                      );
                    }
                  });
                } else {
                  transitionToState(fromState, fromParams, toState, toParams);
                }
              } else {
                transitionToLogin(fromState, fromParams, toState, toParams);
              }
            },
            function (err) {
              transitionToLogin(fromState, fromParams, toState, toParams);
            }
          );
        } else {
          transitionToState(fromState, fromParams, toState, toParams);
        }

        //});

        $rootScope.$emit("dcPageContainer:reloadHeight");
      }
    );

    $scope.$on("destroy", function () {
      stateChangeStartCanceler();
    });

    $analytics.setOptOut(false);

    /*if (!$cookies.get("_cleGDPR")) {
        $cookies.remove("_cle");
    }*/
    // var consents = {};

    $scope.$on("cookieLaw.accept", function () {
      $cookies.put("_cleGDPR", true);
      // consents["analytics"] = { status: 1 };
      // ppms.cm.api('setComplianceSettings', { consents: consents }, console.error);
      // ppms.cm.api('trackSaveChoicesClick');
      $analytics.setOptOut(false);
    });

    $scope.$on("cookieLaw.decline", function () {
      $cookies.put("_cleGDPR", true);
      // consents["analytics"] = { status: 0 };
      // ppms.cm.api('setComplianceSettings', { consents: consents }, console.error);
      // ppms.cm.api('trackSaveChoicesClick');
      $rootScope.$broadcast("cookieLaw.dismiss");
      $analytics.setOptOut(true);
    });
  },
];



// WEBPACK FOOTER //
// ./src/ui/app/controller/AppController.js